export class OrganizationUserResetPasswordEnrollmentRequest {
  resetPasswordKey: string;
}
